import { AuthGuard } from '../app.authGuard';
import { NgModule, Injectable } from '@angular/core';
import { Routes, Router, RouterModule, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, RunGuardsAndResolvers, Route } from '@angular/router';
import { AppConfig } from '../app.config';

import { ConfigureComponent } from './configure/configure.component';
import { PhBhpConfigureCountryComponent } from './ph-bhp-configure-country/ph-bhp-configure-country.component';
import { PhBhpConfigureDepartmentComponent } from './ph-bhp-configure-department/ph-bhp-configure-department.component';
import { PhBhpConfigureImageLibraryComponent } from './ph-bhp-configure-image-library/ph-bhp-configure-image-library.component';
import { PhBhpConfigureProfessionalCategoryComponent } from './ph-bhp-configure-professional-category/ph-bhp-configure-professional-category.component';
import { PhBhpConfigureSubCategoryComponent } from './ph-bhp-configure-sub-category/ph-bhp-configure-sub-category.component';
import { PhBhpConfigureGeneralComponent } from './ph-bhp-configure-general/ph-bhp-configure-general.component';
import { PhBhpConfigureWardComponent } from './ph-bhp-configure-ward/ph-bhp-configure-ward.component';
import { PhBhpConfigureCommentsComponent } from './ph-bhp-configure-comments/ph-bhp-configure-comments.component';
import { PhBhpConfigureTurorialmanagementComponent } from './ph-bhp-configure-turorialmanagement/ph-bhp-configure-turorialmanagement.component';
import { PhBhpConfigureTurorialComponent } from './ph-bhp-configure-turorial/ph-bhp-configure-turorial.component';
import { PhBhpConfigureImageInstitutionComponent } from './ph-bhp-configure-image-institution/ph-bhp-configure-image-institution.component';
import { PhBhpConfigureCheckCommentsComponent } from './ph-bhp-configure-check-comments/ph-bhp-configure-check-comments.component';
import { PhBhpConfigureCountrySettingsComponent } from './ph-bhp-configure-country-settings/ph-bhp-configure-country-settings.component';
import { PhBhpConfigureCheckPredefinedCommentsComponent } from './ph-bhp-configure-check-predefined-comments/ph-bhp-configure-check-predefined-comments.component';

@Injectable({ providedIn: 'root' })
export class CoutryActivate implements CanActivate {
  constructor(private router: Router, private config: AppConfig) {

  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.config.userData.roleName.roleId == 1) {
      this.router.navigate(['/configure/country']);
    }
    else if (this.config.userData.roleName.roleId == 2) {
      this.router.navigate(['/configure/country-settings']);
    }
    else if (this.config.userData.roleName.roleId == 3) {
      this.router.navigate(['/configure/image-institution']);
    } else if (this.config.userData.roleName.roleId == 4) {
      this.router.navigate(['/configure/general']);
    }

    return false;
  }
}

const options = {
  runGuardsAndResolvers: "always" as RunGuardsAndResolvers
};

export var ConfigureRouterModule: Route =      {
  path: 'configure', component: ConfigureComponent, children: [
    { path: 'activate', component: PhBhpConfigureDepartmentComponent, canActivate: [AuthGuard,CoutryActivate] },
    { path: 'country', component: PhBhpConfigureCountryComponent, canActivate: [AuthGuard] },
    { path: 'department', component: PhBhpConfigureDepartmentComponent, canActivate: [AuthGuard] },
    { path: 'image-library', component: PhBhpConfigureImageLibraryComponent, canActivate: [AuthGuard] },
    { path: 'image-institution', component: PhBhpConfigureImageInstitutionComponent, canActivate: [AuthGuard] },
    { path: 'professional-category', component: PhBhpConfigureProfessionalCategoryComponent, canActivate: [AuthGuard] },
    { path: 'sub-category', component: PhBhpConfigureSubCategoryComponent, canActivate: [AuthGuard] },
    { path: 'general', component: PhBhpConfigureGeneralComponent, canActivate: [AuthGuard] },
    { path: 'country-settings', component: PhBhpConfigureCountrySettingsComponent, canActivate: [AuthGuard] },
    { path: 'wards', component: PhBhpConfigureWardComponent, canActivate: [AuthGuard] },
    { path: 'comments', component: PhBhpConfigureCommentsComponent, canActivate: [AuthGuard] },
    { path: 'check-comments', component: PhBhpConfigureCheckCommentsComponent, canActivate: [AuthGuard] },
    { path: 'check-predefined-comments', component: PhBhpConfigureCheckPredefinedCommentsComponent, canActivate: [AuthGuard] },
    { path: 'tutorial', component: PhBhpConfigureTurorialmanagementComponent, canActivate: [AuthGuard] },
    { path: 'tutorial/edit/:tutorialID', component: PhBhpConfigureTurorialComponent, canActivate: [AuthGuard] },
    { path: 'tutorial/add', component: PhBhpConfigureTurorialComponent, canActivate: [AuthGuard] },
    { path: '', redirectTo: 'activate', pathMatch: 'full', canActivate: [AuthGuard,CoutryActivate] },
    { path: '**', redirectTo: 'activate', canActivate: [AuthGuard,CoutryActivate] }
  ]
}

